/*
 * Newsletter submission confirmation.
 *
 * The Shopify customer/newsletter form is captcha-protected, so it must submit
 * natively (a full page reload) — AJAX would strip the required captcha token.
 * After a successful submit Shopify reloads the page and re-renders the form's
 * success message, but that message lives in the footer and the reload lands the
 * user at the top of the page, so it goes unseen.
 *
 * This script detects the server-rendered success/error message on load and
 * surfaces a prominent toast, and scrolls the inline message into view, so the
 * outcome is unmistakable. It only acts right after a submit (the message
 * elements only exist when form.posted_successfully? or form.errors is set).
 */
(function () {
  'use strict';

  var SUCCESS_SEL = '.footer-brand__form-message--success, .newsletter-form__message--success';
  var ERROR_SEL =
    '.footer-brand__form-message--error, ' +
    '.newsletter-form__message.form__message:not(.newsletter-form__message--success)';

  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  onReady(function () {
    var success = document.querySelector(SUCCESS_SEL);
    var error = success ? null : document.querySelector(ERROR_SEL);
    if (!success && !error) return; // no submit just happened

    var el = success || error;
    var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
    if (success && !text) text = "Thanks for subscribing — you're on the list!";
    if (error && !text) text = 'Something went wrong. Please check your email and try again.';

    showToast(text, !!success);

    // Secondary confirmation: bring the form's inline message into view.
    var form = el.closest('form');
    if (form) {
      try { form.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
    }
  });

  function showToast(text, ok) {
    var check =
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="none" stroke="#fff" ' +
      'stroke-width="3" stroke-linecap="round" stroke-linejoin="round" d="M5 12.5l4 4 10-10"/></svg>';
    var bang =
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="none" stroke="#fff" ' +
      'stroke-width="3" stroke-linecap="round" d="M12 7v6M12 16.5v.4"/></svg>';

    var el = document.createElement('div');
    el.className = 'ct-newsletter-toast' + (ok ? '' : ' ct-newsletter-toast--error');
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    el.innerHTML =
      '<span class="ct-newsletter-toast__icon">' + (ok ? check : bang) + '</span>' +
      '<span class="ct-newsletter-toast__text"></span>' +
      '<button type="button" class="ct-newsletter-toast__close" aria-label="Dismiss">×</button>';
    el.querySelector('.ct-newsletter-toast__text').textContent = text;
    document.body.appendChild(el);

    requestAnimationFrame(function () { el.classList.add('is-visible'); });

    var timer = setTimeout(dismiss, 6000);
    function dismiss() {
      clearTimeout(timer);
      el.classList.remove('is-visible');
      setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 400);
    }
    el.querySelector('.ct-newsletter-toast__close').addEventListener('click', dismiss);
  }
})();
